import type { DegreeDetailRedesignData } from "@/monarch/rules/degreeDetailRedesignTrafficV5_2/types";

import type { DegreeDetailPageV5_2Default } from "./DegreeLearnerTestimonials/utils/learnerTestimonialsDefaults";

/**
 * Merges Monarch `degreeDetailPageRedesignTestV52` payload over static V5_2 defaults.
 * Monarch wins per-field when it provides non-empty content; otherwise static fallback.
 */
export function mergeDegreeDetailV5_2WithMonarch(
  staticData: DegreeDetailPageV5_2Default,
  monarchData: DegreeDetailRedesignData | undefined,
): DegreeDetailPageV5_2Default {
  if (!monarchData) {
    return staticData;
  }

  const hasMonarchTestimonials =
    Array.isArray(monarchData.learnerTestimonials) &&
    monarchData.learnerTestimonials.length > 0;

  const learnerTestimonials = hasMonarchTestimonials
    ? monarchData.learnerTestimonials!
    : staticData.learnerTestimonials;

  const hasMonarchStats =
    Array.isArray(monarchData.stats) && monarchData.stats.length > 0;
  const stats = hasMonarchStats ? monarchData.stats! : staticData.stats;

  const statsSectionTitle =
    monarchData.statsSectionTitle?.trim() || staticData.statsSectionTitle;

  const hasMonarchAccreditationBody =
    Boolean(monarchData.accreditation?.title?.trim()) ||
    Boolean(monarchData.accreditation?.description?.trim());

  const accreditation = hasMonarchAccreditationBody
    ? {
        ...staticData.accreditation,
        ...monarchData.accreditation,
      }
    : staticData.accreditation;

  const showAccreditationSection =
    monarchData.showAccreditationSection !== undefined
      ? monarchData.showAccreditationSection
      : staticData.showAccreditationSection;

  return {
    learnerTestimonials,
    stats,
    statsSectionTitle,
    accreditation,
    showAccreditationSection,
  };
}
